export default "__VITE_ASSET__ebdc2a25__"